import { takeEvery } from "redux-saga/effects";

const watchUserFoundThen = then => takeEvery("USER_FOUND", then);

export { watchUserFoundThen };



// WEBPACK FOOTER //
// ./src/store/sagas/shared.js